import { SystemPage } from '@/components/system/system-page'
import { Button } from '@/components/ui/button'
import { Link } from '@tanstack/react-router'
import { Home, ShieldOff } from 'lucide-react'

export function ForbiddenPage() {
  return (
    <SystemPage
      code="403"
      icon={ShieldOff}
      tone="warning"
      title="Доступ заборонено"
      hint="У вас недостатньо прав для перегляду цієї сторінки. Зверніться до адміністратора цеху, якщо потрібен доступ."
      primaryAction={
        <Button asChild>
          <Link to="/projects/">
            <Home className="size-3.5" />
            На головну
          </Link>
        </Button>
      }
    />
  )
}
